import NextImage from "../elements/image";

import styles from "@/styles/app-block.module.scss";

const DoubleAppBlock = ({ data }) => {
  return (
    <section className="bg-onmoBeige md:bg-transparent">
      <div className="grid grid-cols-1 md:grid-cols-11 px-0 py-10 md:py-12 md:px-0 lg:p-20 max-w-1424 mx-auto ">
        <div className="flex flex-col md:flex-row md:gap-2 lg:gap-10 justify-center col-span-6">
          <h1
            className={`max-w-[332px] mx-auto text-center block md:hidden ${styles.titleUpdated}`}
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          {data.appImages.data.map((v, i) => (
            <div
              className={`${
                i >= 1 ? "hidden md:block" : "flex justify-center py-5 md:py-0"
              }`}
              key={i}
            >
              <NextImage
                media={v}
                width={v.attributes.width}
                height={v.attributes.height}
              />
            </div>
          ))}
        </div>
        <div className="grid px-5 py-10 md:p-10 md:px-14 gap-5 content-center col-span-5">
          <h1
            className={`max-w-[426px] hidden md:block ${styles.titleUpdated}`}
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          <p className={styles.descriptionUpdated}>{data.description}</p>
        </div>
      </div>
    </section>
  );
};

export default DoubleAppBlock;
